exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mce-tinymce:not(.mce-fullscreen) iframe{height:300px!important}", ""]);

// exports
